module.exports = __webpack_public_path__ + "img/qa.a0b2649.webp";